import { PropsWithChildren } from 'react'
import { usePersonalizationConfig } from '~/app/features/Gallery/hooks/usePersonalizationConfig'

import { ReduxBridge } from './ReduxBridge'

export const DesignPersonalizationProvider = ({ children }: PropsWithChildren) => {
  const { isEnabled } = usePersonalizationConfig()

  // If personalization is not enabled, return only the children
  if (!isEnabled) {
    return <>{children}</>
  }

  return (
    <>
      <ReduxBridge />
      {children}
    </>
  )
}
